module.exports = __webpack_public_path__ + "static/media/defiPulse.6d4bb6b3.png";